(function () {
  const STORAGE_KEY = 'zb_recently_viewed';
  const MAX_ITEMS = 20;

  const handle = window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  if (!handle) return;

  try {
    const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const updated = [handle, ...existing.filter(h => h !== handle)].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (e) { }
})();
